<template>
  <modal
      @close="$emit('close')"
      class="custom-popup link-email-popup"
  >
    <template slot="header">
      <div v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['ukrTreasures_LinkForEmail'])"></div>
        {{$t('ukrTreasures_LinkForEmail.localization_value.value')}}
      </div>
    </template>
    <template slot="body">
      <div class="custom-popup__content">
        <div class="custom-row">
          <div class="custom-col"
               v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['ukrTreasures_LinkProductToSend'])"></div>
            <DefaultInput
              :label="$t('ukrTreasures_LinkProductToSend.localization_value.value')"
              :value="link"
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="d-flex align-items-center flex-wrap"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_copy'])"></div>
        <MainButton
            :value="$t('common_copy.localization_value.value')"
            class="import-transaction__btn-i"
            :ico="true"
            @click.native="copy"
        >
          <template slot="ico">
            <CopyIcoWhite/>
          </template>
        </MainButton>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../../../commonModals/Modal.vue'
  import MainButton from '../../../../UI/buttons/MainButton/MainButton.vue'
  import DefaultInput from "../../../../UI/inputs/DefaultInput/DefaultInput";
  import CopyIcoWhite from "../../../../../../public/img/UI-group/copy-icon-white.svg?inline"

  export default {
    name: "LinkEmailPopup",

    components: {
      Modal,
      MainButton,
      DefaultInput,
      CopyIcoWhite
    },

    props: {
      link: String,
    },

    data(){
      return {
        text: 'https://www.paypalobjects.com/en_US/i/btn/btn_buynow_LG.gif',
      }
    },

    mounted() {

    },

    methods: {
      copy() {
        this.copyLink(this.link)
        this.openNotify('success', 'common__notificationCopied')
        this.$emit('close')
      }
    }
  }

</script>

<style lang="scss">
  .link-email-popup{

    .modal-component__inner{
      max-width: 758px;
    }
  }

</style>
